// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip--tooltip--506fR","label":"Tooltip--label--uUoio","arrow":"Tooltip--arrow--+mHAE"};